import { Link } from 'react-router-dom';
import { hotResources, getCategoryName } from '@/mocks/resources';
import { formatViews } from '@/utils/format';

export default function HotList() {
  return (
    <section className="mx-auto w-full px-4 md:px-8">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            根据浏览热度为你挑选，大家最近都在看
          </p>
        </div>
        <span className="hidden items-center gap-1 text-sm font-label text-foreground-600 sm:inline-flex">
          <i className="ri-fire-line text-accent-600" />
          实时热度榜
        </span>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {hotResources.map((item, idx) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
          >
            <div className="relative h-[104px] w-[72px] shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title} 热门国语影音封面`}
                title={`${item.title} 热门推荐`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold font-label ${
                    idx < 3
                      ? 'bg-accent-500 text-foreground-950'
                      : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {idx + 1}
                </span>
                <h3 className="truncate font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h3>
              </div>
              <p className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600">
                <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                  {getCategoryName(item.category)}
                </span>
                <span>{item.year}</span>
                <span>·</span>
                <span>{item.region}</span>
              </p>
              <div className="mt-2 flex items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 text-accent-700">
                  <i className="ri-star-fill" />
                  {item.rating.toFixed(1)}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {formatViews(item.views)}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}